module.exports = __webpack_public_path__ + "static/media/17230020-jvh1wSgs.31369d42.JPG";